"use strict";
import DataStoreService from "../accounts_payable/data_store_service";
import ApiService from "../services/api_service";
export default {
  create: function(params) {
    return ApiService.addErrorHandler($.ajax({
      url: "/api/factor_invoices/",
      data: JSON.stringify(params),
      contentType: "application/json",
      dataType: "json",
      type: "post",
      success: function(data) {
        DataStoreService.updateStores(data);
      }
    }));
  },
  toggleClientOrDebtorOnBol: function(factorInvoiceId, value, flags) {
    const params = {
      factor_invoice: { id: factorInvoiceId, client_or_debtor_on_bol: value },
      audit_flags: flags
    };
    return ApiService.addErrorHandler($.ajax({
      url: "/api/factor_invoices/",
      data: JSON.stringify(params),
      contentType: "application/json",
      dataType: "json",
      type: "post",
      success: function(data) {
        DataStoreService.updateStores(data);
      }
    }));
  },
  abandon: function(factorInvoiceId, reason) {
    return ApiService.addErrorHandler(
      $.post(
        "/api/factor_invoices/" + factorInvoiceId + "/abandon",
        { reason }
      ).then(function(data) {
        DataStoreService.updateStores(data);
        return data;
      })
    );
  },
  revive: function(factorInvoiceId) {
    return ApiService.addErrorHandler(
      $.post("/api/factor_invoices/" + factorInvoiceId + "/revive").then(function(data) {
        DataStoreService.updateStores(data);
        return data;
      })
    );
  },
  markAsException: function(factorInvoiceId, emailId) {
    const url = `/api/factor_invoices/${factorInvoiceId}/save_with_errors` + (emailId ? `?email_id=${emailId}` : "");
    return ApiService.addErrorHandler(
      $.post(url).then(DataStoreService.responseHandler, _.identity)
    );
  },
  markAsProcessed: function(factorInvoiceId, options = {}) {
    return ApiService.addErrorHandler(
      $.post("/api/factor_invoices/" + factorInvoiceId + "/mark_as_processed", options).then(DataStoreService.responseHandler, _.identity)
    );
  },
  mergeInvoices: function(targetInvoiceId, otherInvoiceId) {
    return ApiService.addErrorHandler(
      $.post("/api/factor_invoices/" + targetInvoiceId + "/merge_from", { other_invoice_id: otherInvoiceId }).then(DataStoreService.responseHandler, _.identity)
    );
  },
  searchInvoices: function(filters) {
    return ApiService.addErrorHandler(
      $.get("/api/factor_invoices/search", filters).then(DataStoreService.responseHandler, _.identity).then((data) => {
        return data.results;
      })
    );
  }
};
